import { Injectable, Injector } from '@angular/core';



import { $frontendTypes } from './FootprintEdi.frontend.types'

@Injectable({ providedIn: 'root' })
export class FootprintEdi_FrontendFlowService {

  constructor(
    private injector: Injector
  ) {
  }

  public FootprintEdi: FootprintEdi_FrontendFlowService = this;

  // injecting lazily in order to avoid circular dependencies
}
